export const TRANSACTION_COLUMNS = {
  SELECT: "SELECT",
  DATE: "DATE",
  FROM: "FROM",
  VENDOR: "VENDOR",
  DESCRIPTION: "DESCRIPTION",
  AMOUNT: "AMOUNT",
  CATEGORY: "CATEGORY",
  DAILY_ENTRY: "DAILY_ENTRY",
  OPTIONS: "OPTIONS",
  INVOICE: "INVOICE",
  COMMENTS: "COMMENTS",
  MEMO: "MEMO",
  CLASSIFICATION: "CLASSIFICATION",
  SUGGESTED: "SUGGESTED",
} as const;

export const TRANSACTION_COLUMNS_OPTIONS = [
  {
    label: "Date",
    value: TRANSACTION_COLUMNS.DATE,
  },
  {
    label: "Source",
    value: TRANSACTION_COLUMNS.FROM,
  },
  {
    label: "To/From",
    value: TRANSACTION_COLUMNS.VENDOR,
  },
  {
    label: "Description",
    value: TRANSACTION_COLUMNS.DESCRIPTION,
  },
  {
    label: "Amount",
    value: TRANSACTION_COLUMNS.AMOUNT,
  },
  {
    label: "Category",
    value: TRANSACTION_COLUMNS.CATEGORY,
  },
  {
    label: "Classification",
    value: TRANSACTION_COLUMNS.CLASSIFICATION,
  },
  {
    label: "Daily Entry",
    value: TRANSACTION_COLUMNS.DAILY_ENTRY,
  },
  {
    label: "Invoice/Bill",
    value: TRANSACTION_COLUMNS.INVOICE,
  },
  {
    label: "Invoice/Bill Suggestion",
    value: TRANSACTION_COLUMNS.SUGGESTED,
  },
  {
    label: "Comments",
    value: TRANSACTION_COLUMNS.COMMENTS,
  },
  {
    label: "Memo",
    value: TRANSACTION_COLUMNS.MEMO,
  },
];

export const FIXED_TRANSACTION_COLUMNS: (keyof typeof TRANSACTION_COLUMNS)[] = [
  TRANSACTION_COLUMNS.SELECT,
  TRANSACTION_COLUMNS.DATE,
  TRANSACTION_COLUMNS.AMOUNT,
  TRANSACTION_COLUMNS.CATEGORY,
  TRANSACTION_COLUMNS.OPTIONS,
];

export const CASH_FLOW = {
  DEBIT: "DEBIT",
  CREDIT: "CREDIT",
  ALL: "ALL",
} as const;

export const CASH_FLOW_LABEL: Record<keyof typeof CASH_FLOW, string> = {
  DEBIT: "Money Out",
  CREDIT: "Money In",
  ALL: "All",
};

export const REFRESH_TYPE = {
  ATTACHMENTS: "attachments",
  TRANSACTIONS: "transactions",
} as const;

export type RefreshType = (typeof REFRESH_TYPE)[keyof typeof REFRESH_TYPE];

export const ENTRY_SOURCE = {
  BANK: "BANK",
  CREDIT_CARD: "CREDIT_CARD",
  JOURNAL_ENTRY: "JOURNAL_ENTRY",
  INVOICE: "INVOICE",
  BILL: "BILL",
} as const;

export type EntrySource = (typeof ENTRY_SOURCE)[keyof typeof ENTRY_SOURCE];

export const ENTRY_SOURCE_LABEL: Record<EntrySource, string> = {
  [ENTRY_SOURCE.BANK]: "Bank",
  [ENTRY_SOURCE.CREDIT_CARD]: "Credit card",
  [ENTRY_SOURCE.JOURNAL_ENTRY]: "Journal entry",
  [ENTRY_SOURCE.INVOICE]: "Invoice",
  [ENTRY_SOURCE.BILL]: "Bill",
};
